import React from 'react';

const IsRequiredSymbol = (props) => {
    const { condition } = props;

    return (
        <React.Fragment>
            {condition && <h4 style={{color: 'red', marginLeft: '0px', marginRight: '10px'}}>*</h4>}
        </React.Fragment>
    )
}

export default IsRequiredSymbol;